import { c as _c } from "react/compiler-runtime";
import { Dialog, Transition } from "@headlessui/react";
import { clx } from "@medusajs/ui";
import React, { Fragment } from "react";
import { ModalProvider, useModal } from "@lib/context/modal-context";
import X from "@modules/common/icons/x";
type ModalProps = {
  isOpen: boolean;
  close: () => void;
  size?: "small" | "medium" | "large" | "full";
  search?: boolean;
  children: React.ReactNode;
  'data-testid'?: string;
};
const Modal = t0 => {
  const $ = _c(29);
  const {
    isOpen,
    close,
    size: t1,
    search: t2,
    children,
    "data-testid": dataTestId
  } = t0;
  const size = t1 === undefined ? "medium" : t1;
  const search = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-200" leaveFrom="opacity-100" leaveTo="opacity-0"><div className="fixed inset-0 bg-opacity-75 backdrop-blur-md  h-screen" /></Transition.Child>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = search ? "px-0 py-0 sm:p-4" : "p-4";
  const t5 = !search;
  let t6;
  if ($[1] !== search || $[2] !== t4 || $[3] !== t5) {
    t6 = clx("flex min-h-full h-full justify-center text-center", t4, {
      "items-center": t5,
      "items-start": search
    });
    $[1] = search;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const t7 = search ? "h-full max-h-full p-0 sm:p-5" : "max-h-[75vh] h-fit p-5";
  const t8 = size === "small";
  const t9 = size === "medium";
  const t10 = size === "large";
  const t11 = size === "full";
  const t12 = !search;
  let t13;
  if ($[5] !== search || $[6] !== t10 || $[7] !== t11 || $[8] !== t12 || $[9] !== t7 || $[10] !== t8 || $[11] !== t9) {
    t13 = clx("flex flex-col justify-start w-full transform text-left align-middle transition-all", t7, {
      "max-w-md": t8,
      "max-w-xl": t9,
      "max-w-3xl": t10,
      "max-w-full h-full": t11,
      "bg-transparent shadow-none": search,
      "bg-white shadow-xl border rounded-rounded": t12
    });
    $[5] = search;
    $[6] = t10;
    $[7] = t11;
    $[8] = t12;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
    $[12] = t13;
  } else {
    t13 = $[12];
  }
  let t14;
  if ($[13] !== children || $[14] !== close) {
    t14 = <ModalProvider close={close}>{children}</ModalProvider>;
    $[13] = children;
    $[14] = close;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] !== dataTestId || $[17] !== t13 || $[18] !== t14) {
    t15 = <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-200" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95"><Dialog.Panel data-testid={dataTestId} className={t13}>{t14}</Dialog.Panel></Transition.Child>;
    $[16] = dataTestId;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t15 || $[21] !== t6) {
    t16 = <div className="fixed inset-0 overflow-y-hidden"><div className={t6}>{t15}</div></div>;
    $[20] = t15;
    $[21] = t6;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== close || $[24] !== t16) {
    t17 = <Dialog as="div" className="relative z-[75]" onClose={close}>{t3}{t16}</Dialog>;
    $[23] = close;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== isOpen || $[27] !== t17) {
    t18 = <Transition appear={true} show={isOpen} as={Fragment}>{t17}</Transition>;
    $[26] = isOpen;
    $[27] = t17;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  return t18;
};
const Title: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(8);
  const {
    children
  } = t0;
  const {
    close
  } = useModal();
  let t1;
  if ($[0] !== children) {
    t1 = <div className="text-large-semi">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <X size={20} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== close) {
    t3 = <div><button onClick={close} data-testid="close-modal-button">{t2}</button></div>;
    $[3] = close;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t1 || $[6] !== t3) {
    t4 = <Dialog.Title className="flex items-center justify-between">{t1}{t3}</Dialog.Title>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const Description: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Dialog.Description className="flex text-small-regular text-ui-fg-base items-center justify-center pt-2 pb-4 h-full">{children}</Dialog.Description>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const Body: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex justify-center">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
const Footer: React.FC<{
  children: React.ReactNode;
}> = t0 => {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <div className="flex items-center justify-end gap-x-4">{children}</div>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
Modal.Title = Title;
Modal.Description = Description;
Modal.Body = Body;
Modal.Footer = Footer;
export default Modal;